import React from 'react';
import styles from './index.less';
const SubForm = (props)=>{
    return(
        <div className={styles.subForm}>
            {props.children}
        </div>
    );
};

export default SubForm;



// WEBPACK FOOTER //
// ./src/components/SubForm/index.js